import { ViewHook } from 'phoenix_live_view';

interface EnterSubmitDataset extends DOMStringMap {
  triggeredEventName: string | undefined;
  eventTarget: string | undefined;
  clearableInputId: string | undefined;
}

class EnterSubmitProps {
  public triggeredEventName: string = '';
  public eventTarget: string = '';
  public clearableInput: HTMLInputElement | null = null;
}

export default {
  EnterSubmit: {
    mounted() {
      const dataset = this.el.dataset as EnterSubmitDataset;
      const props = new EnterSubmitProps();

      props.triggeredEventName = dataset.triggeredEventName ?? '';
      props.eventTarget = dataset.eventTarget ?? '';
      props.clearableInput = document.getElementById(dataset.clearableInputId ?? '') as HTMLInputElement;

      this.el.addEventListener('keydown', e => {
        if (e.key == 'Enter' && e.shiftKey == false) {
          if (props.eventTarget && props.triggeredEventName) {
            this.pushEventTo(props.eventTarget, props.triggeredEventName, {});

            // Clearing content of the input
            if (props.clearableInput) {
              props.clearableInput.value = '';
              props.clearableInput.dispatchEvent(new Event('clearContent', { bubbles: true }));
            }
          }
        }
      });
    },

    updated() {},
  } as ViewHook,
};
